export default "__VITE_ASSET__xdyuCqkK__"